module.exports = __webpack_public_path__ + "img/attraction-1-full.66bc57d7.jpg";